import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IClaimMultiSignWallet, IMultiSignWallet } from 'types/api/ApiResponseTypes';

export const useSidebar = () => {
  const location = useLocation();

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAcceptInviteDialogOpened, setAcceptInviteDialogOpened] = useState(false);
  const [successPopupTitle, setSuccessPopupTitle] = useState('');
  const [successDialogContent, setSuccessDialogContent] = useState('');
  const [isSuccessPopupOpened, setSuccessPopupOpened] = useState(false);
  const [isReceiveBtcDialogOpen, setReceiveBtcDialogOpen] = useState(false);
  const [isSidebarHidden, setSidebarHidden] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [safes, setSafes] = useState<IMultiSignWallet[]>([]);
  const [pendingSafes, setPendingSafes] = useState<IClaimMultiSignWallet[]>([]);

  useEffect(() => {
    setDropdownOpen(false);
  }, [location.pathname]);

  return useMemo(
    () => ({
      isDropdownOpen,
      setDropdownOpen,
      isDropdownVisible,
      setIsDropdownVisible,
      isSidebarVisible,
      setSidebarVisible,
      isLoading,
      setIsLoading,
      isAcceptInviteDialogOpened,
      setAcceptInviteDialogOpened,
      successPopupTitle,
      setSuccessPopupTitle,
      successDialogContent,
      setSuccessDialogContent,
      isSuccessPopupOpened,
      setSuccessPopupOpened,
      isReceiveBtcDialogOpen,
      setReceiveBtcDialogOpen,
      isSidebarHidden,
      setSidebarHidden,
      isMobileMenuOpen,
      setMobileMenuOpen,
      safes,
      setSafes,
      pendingSafes,
      setPendingSafes,
    }),
    [
      isDropdownOpen,
      isDropdownVisible,
      isSidebarVisible,
      isLoading,
      isAcceptInviteDialogOpened,
      successPopupTitle,
      successDialogContent,
      isSuccessPopupOpened,
      isReceiveBtcDialogOpen,
      isSidebarHidden,
      isMobileMenuOpen,
      safes,
      pendingSafes,
    ]
  );
};
